import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-bubble',
    standalone: true,
    imports: [],
    templateUrl: './bubble.component.html',
})
export class BubbleComponent {
    @Input() color: string = '#95D1F3';
    @Input() classes: string = '';
}
